module.exports = __webpack_public_path__ + "img/bg2.fda34680.png";